define('src/views/form-view',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils'
], function(_, Backbone, Mustache, U) {

    /**
     * Backbone view that encapsulate common behaviors of a form view.
     * It triggers custom events and deals with copying a master model, also
     * keeping a carbon copy as a reference.
     *
     */
    var VForm = Backbone.Epoxy.View.extend({
        events: {},

        /**
         * Overwrite the default constructor to extends events.
         */
        constructor: function(options) {
            this.submitting = false;
            options = options || {};

            if (options.fields) {
                this.fields = options.fields;
            }
            // apply additional events
            _.defaults(this.events, {
                "submit": "_onSubmit",
                "reset": "_onReset",
            });

            Backbone.View.apply(this, arguments);
        },

        /**
         * Happens just before init.
         */
        _ensureElement: function() {
            if (this.model) {
                this.initModel();
            }
            VForm.__super__._ensureElement.apply(this, arguments);
        },

        initModel: function() {
            this.modelMaster = this.model;
            this.masterCarbon = this.modelMaster.clone();
            this.model = this.modelMaster.clone();

            this.listenTo(this.modelMaster, 'change', this.onMasterChanged);
        },

        setModel: function(model) {
            this.modelMaster = model;
            this.model.reset(model.attributes);
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
        },

        getModel: function() {
            return this.modelMaster;
        },

        getFields: function() {
            return _.result(this, 'fields', false);
        },

        getAttributes: function() {
            var fields = this.getFields(),
                model = this.model;
            return fields ? model.pick(fields.concat(model.idAttribute)) : model.attributes;
        },

        applyModel: function() {
            this.modelMaster.set(this.getAttributes());
            this.setPristine();
            this._onModelApplied();
        },

        setPristine: function() {
            var attrs = this.modelMaster.attributes;
            this.masterCarbon.reset(attrs);
            this.model.reset(attrs);
        },

        isDirty: function() {
            return Boolean(this.masterCarbon.changedAttributes(this.getAttributes()));
        },

        isCreate: function() {
            return this.model.isNew();
        },
        isEdit: function() {
            return !this.isCreate();
        },

        isSubmitting: function() {
            return Boolean(this.submitting);
        },

        onValidate: _.noop,
        validate: function() {
            return this.onValidate() !== false && this.model.isValid();
        },

        submit: function() {
            if (this.submitting) return;

            this.submitting = true;
            if (this.onSubmit() === false) {
                this._cleanup();
                return false; // prevent submit
            }

            if (!this.validate()) {
                return this._onInvalid();
            }

            return this.save();
        },

        save: function(attrs, options) {

            if (this._onSave() === false) {
                this._cleanup();
                return false; // prevent submit
            }

            var model = this.model;
            if (!attrs && !model.isNew()) {
                attrs = this.modelMaster.changedAttributes(this.getAttributes());
            }

            if (attrs !== false) {
                if (_.result(model, 'urlRoot') || _.result(model.collection, 'url')) {
                    model.save(attrs, _.extend({
                        patch: !model.isNew(),
                        context: this,
                        success: this._onSuccess,
                        error: this._onError,
                        validate: false, // already validated
                    }, options));
                } else {
                    this._onSuccess();
                }

            } else {
                this._onUnchanged();
            }
        },

        ////////////
        // events //
        ////////////
        onMasterChanged: function() {
            if (!this.isDirty()) {
                this.setPristine();
            }
        },

        onSubmit: _.noop, // to override in the child view
        _onSubmit: function(e) {
            e.preventDefault();
            if (this.submit() === false) {
                this.submitting = false;
            }
        },
        onReset: function(e) {},
        _onReset: function(e) {
            if (this.onReset(e) !== false) {
                e.preventDefault();
                this.setPristine();
                this.trigger('form:cancel');
            }
        },
        onSuccess: _.noop,
        _onSuccess: function() {
            if (this.onSuccess() !== false) {
                this.applyModel();
                this._cleanup();
                this.trigger('form:success');
            }
        },

        onError: _.noop,
        _onError: function(model, response) {
            if (this.onError(response) !== false) {
                this._cleanup();
                this.trigger('form:error');
                if (model) {
                    window.Rollbar.error("form-view.js in _onError\n" + JSON.stringify(model), response);
                } else {
                    window.Rollbar.error("form-view.js in _onError\n", response);
                }

            }
        },

        onInvalid: _.noop,
        _onInvalid: function() {
            if (this.onInvalid() !== false) {
                this._cleanup();
                this.trigger('form:invalid');
            }
        },

        onUnchanged: _.noop,
        _onUnchanged: function() {
            if (this.onUnchanged() !== false) {
                // no changes, re-activate the form.
                this._cleanup();
                this.trigger('form:success'); // no changes saving is still a success
            }
        },

        onSave: _.noop,
        _onSave: function() {
            return this.onSave();
        },

        onCleanup: _.noop,
        _cleanup: function() {
            if (this.onCleanup() !== false) {
                this.submitting = false;
            }
        },

        onModelApplied: _.noop,
        _onModelApplied: function() {
            if (this.onModelApplied() !== false) {
                this.trigger('model:applied');
            }
        },
    });

    return VForm;
});

